/* eslint-disable no-sparse-arrays */
import React, { lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

const publicRoutes = [
  {
    path: "/",
    exact: true,
    component: lazy(() => import("views/epass/tnds_otov2/forms/introduce")),
  },
];

export default function Routes() {
  return (
    <Suspense fallback={<div></div>}>
      <Router basename="/b8b127d2">
        <Switch>
          {publicRoutes.map((route, index) => (
            <Route key={index} path={route.path} exact={route.exact}>
              <route.component />
            </Route>
          ))}
        </Switch>
      </Router>
    </Suspense>
  );
}
